<template>
  <span>&nbsp;</span>
</template>
<script>
import auth from '@/lib/auth'
import router from '@/router'
import {AlertMessages, Alert as AlertType} from '@/lib/definitions'
import {newAlert} from '@/lib/eventHub'

export default {
  mounted() {
    // Parse Auth0 redirect
    auth.auth0.parseHash((err, result) => {
      if (err) {
        console.log('Validate: error => ', err)
        newAlert(`${err.error} - ${err.errorDescription}`)
        this.$router.push({name: 'login'})
        return
      }
      console.log('Validate: result => ', result)
      if (result && result.idToken) {
        auth
          .login(result)
          .then(() => {
            const redirect = result.state ? result.state : '/'
            router.push(redirect)
          })
          .catch(error => {
            newAlert(
              `${error.devMessage} (${error.devCode})`,
              AlertType.ERROR,
              false
            )
          })
      } else {
        newAlert(AlertMessages.VALIDATE_UNKNOWN_ERROR)
        this.$router.push({name: 'login'})
      }
    })
  }
}
</script>
